import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";

export default function TestModal(props) {
    return (
      <CustomModal title="Test Modal" id="TestModal">
        <CustomModalContent className="">
            <h1>Some Content</h1>
        </CustomModalContent>
  
        <CustomModalFooter>
          <ModalCloseButton id="TestModal" />
          <ModalPrimaryButton text="Test" />
        </CustomModalFooter>
      </CustomModal>
    );
  }